import React from 'react';
import { Box, EmptyServicesListIcon, Text } from '@common-fe/common-fe';

export const TransactionLinkedLmnListEmptyState = (
  <Box
    data-testId="transaction-linked-lmn-list-empty-state"
    pad="spacing24"
    background="canvas"
    round="container2Round"
    align="center"
    justify="center"
  >
    <EmptyServicesListIcon color="iconDisabled" />

    <Text
      margin={{ top: 'spacing24' }}
      color="textDisabled"
      weight={700}
    >
      No LMN added yet
    </Text>
  </Box>
);
